const registration = {
  namespaced: true,
  state: {
    registrationSuccess: false
  },
  mutations: {
    setRegistrationSuccess(state, value) {
      state.registrationSuccess = value;
    },
    clearRegistrationSuccess(state) {
      state.registrationSuccess = false;
    }
  },
  getters: {
    registrationSuccess(state) {
      return state.registrationSuccess;
    }
  }
};

export default registration;
